import { render, staticRenderFns } from "./Valutazione.vue?vue&type=template&id=f8789af0&"
import script from "./Valutazione.vue?vue&type=script&lang=js&"
export * from "./Valutazione.vue?vue&type=script&lang=js&"
import style0 from "./Valutazione.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports